import React from 'react'
import { SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/AppSidebar'
import { AppHeader } from '@/components/AppHeader'
import { XPLedger } from '@/components/XPLedger'
import { RankingProgress } from '@/components/RankingProgress'
import { PayoutPreview } from '@/components/PayoutPreview'
import { useUserProfile } from '@/hooks/useUserProfile'

export default function XPLedgerPage() {
  const { userProfile } = useUserProfile()

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AppSidebar />
        <main className="flex-1">
          <AppHeader userProfile={userProfile} />
          <div className="p-6 space-y-6">
            <div className="max-w-7xl mx-auto">
              <h1 className="text-3xl font-bold mb-6">AURA XP System</h1>
              
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* Current Ranking */}
                <div className="lg:col-span-1">
                  <RankingProgress
                    level={userProfile?.level || 1}
                    auraXP={userProfile?.aura_xp || 0}
                    currentRealm={userProfile?.current_realm || 'Challenger'}
                    consecutiveSubmissions={userProfile?.consecutive_submissions || 0}
                  />
                </div>
                
                {/* XP Transaction History */}
                <div className="lg:col-span-2">
                  <XPLedger />
                </div>
              </div>

              {/* Payout Preview */}
              <div className="mt-8">
                <h2 className="text-2xl font-bold mb-4">Prize Distribution Preview</h2>
                <PayoutPreview />
              </div>
            </div>
          </div>
        </main>
      </div>
    </SidebarProvider>
  )
}